import { throttle } from 'throttle-debounce';

export function init() {
    let footerTitles = document.querySelectorAll('.cl-footer__list-title');
    if (!footerTitles.length) {
        return;
    }
    const toggleClicks = (ev) => {
        let el = ev.target;
        let parentList = el.closest('.cl-footer__list');

        parentList.classList.toggle('state-open');
    };

    const applyClickEvents = () => {
        const mediaQuery = window.matchMedia('(max-width: 1023px)');
        if (mediaQuery.matches) {
            footerTitles.forEach((title) => {
                if (title) {
                    title.addEventListener('click', toggleClicks);
                }
            });
        } else {
            footerTitles.forEach((title) => {
                let parentList = title.closest('.cl-footer__list');
                parentList.classList.remove('state-open');
                title.removeEventListener('click', toggleClicks);
            });
        }
    };

    window.addEventListener(
        'resize',
        throttle(1000, () => {
            applyClickEvents();
        })
    );

    applyClickEvents();
}
